export default "__VITE_ASSET__Dn8GsrD6__"